import {register} from '../vendor/theme-scripts/theme-sections';
import {Ticker} from '../features/ticker';
import {AnnouncementSlider} from '../features/announcement-slider';
import {CartShippingMessage} from '../features/cart-shipping-message';

const selectors = {
  bar: '[data-bar]',
  barSlide: '[data-slide]',
  frame: '[data-ticker-frame]',
  header: '[data-header-wrapper]',
  slider: '[data-announcement-slider]',
  slideValue: 'data-slide',
  tickerScale: '[data-ticker-scale]',
  tickerText: '[data-ticker-text]',
  dataTargetReferrer: 'data-target-referrer',
  slideAttribute: 'data-slide',
};

const classes = {
  mobileClass: 'mobile',
  desktopClass: 'desktop',
};

const sections = {};

class Bar {
  constructor(section) {
    this.container = section.container;
    this.barHolder = this.container.querySelector(selectors.bar);
    this.locationPath = location.href;

    this.slides = this.barHolder.querySelectorAll(selectors.barSlide);
    this.slider = this.barHolder.querySelector(selectors.slider);
    this.hasDeviceClass = '';

    new CartShippingMessage(this.container);

    this.init();
  }

  init() {
    this.removeAnnouncement();

    if (!this.slider) {
      this.initTickers(true);
    } else if (this.slider && this.slides && this.slides.length > 1) {
      this.initSliders();
    } else {
      this.initTickers();
    }
  }

  /**
   * Delete announcement which has a target referrer attribute and it is not contained in page URL
   */
  removeAnnouncement() {
    for (let index = 0; index < this.slides.length; index++) {
      const element = this.slides[index];

      if (!element.hasAttribute(selectors.dataTargetReferrer)) {
        continue;
      }

      if (this.locationPath.indexOf(element.getAttribute(selectors.dataTargetReferrer)) === -1 && !window.Shopify.designMode) {
        element.parentNode.removeChild(element);
      }
    }
  }

  /**
   * Init slider
   */
  initSliders() {
    this.slider = new AnnouncementSlider(this.container, this.slider);
    this.slider.flkty.reposition();

    this.barHolder.addEventListener('theme:announcement:loaded', () => {
      this.initTickers();
    });
  }

  /**
   * Init tickers in sliders
   */
  initTickers(stopClone = false) {
    const frames = this.barHolder.querySelectorAll(selectors.frame);

    frames.forEach((element) => {
      new Ticker(element, stopClone);
    });
  }

  toggleTicker(e, isStoped) {
    const tickerScale = document.querySelector(selectors.tickerScale);
    const element = document.querySelector(`[${selectors.slideValue}="${e.detail.blockId}"]`);

    if (isStoped && element) {
      tickerScale.setAttribute('data-stop', '');
      tickerScale.querySelectorAll(selectors.tickerText).forEach((textHolder) => {
        textHolder.classList.remove('ticker--animated');
        textHolder.style.transform = `translate3d(${-(element.offsetLeft - element.clientWidth)}px, 0, 0)`;
      });
    }

    if (!isStoped && element) {
      tickerScale.querySelectorAll(selectors.tickerText).forEach((textHolder) => {
        textHolder.classList.add('ticker--animated');
        textHolder.removeAttribute('style');
      });
      tickerScale.removeAttribute('data-stop');
    }
  }

  onBlockSelect(e) {
    if (this.slider && typeof this.slider.onBlockSelect === 'function') {
      this.slider.onBlockSelect(e);
    } else {
      const slides = document.querySelectorAll(`[${selectors.slideAttribute}="${e.detail.blockId}"]`);

      slides.forEach((slide) => {
        if (slide.classList.contains(classes.mobileClass)) {
          this.hasDeviceClass = classes.mobileClass;
        }

        if (slide.classList.contains(classes.desktopClass)) {
          this.hasDeviceClass = classes.desktopClass;
        }

        if (this.hasDeviceClass !== '') {
          slide.classList.remove(this.hasDeviceClass);
        }
      });

      this.toggleTicker(e, true);
    }
  }

  onBlockDeselect(e) {
    if (this.slider && typeof this.slider.onBlockDeselect === 'function') {
      this.slider.onBlockDeselect(e);
    } else {
      if (this.hasDeviceClass !== '') {
        const slides = document.querySelectorAll(`[${selectors.slideAttribute}="${e.detail.blockId}"]`);

        slides.forEach((slide) => {
          slide.classList.add(this.hasDeviceClass);
        });
      }

      this.toggleTicker(e, false);
    }
  }
}

const bar = {
  onLoad() {
    sections[this.id] = [];
    sections[this.id].push(new Bar(this));
  },
  onBlockSelect(e) {
    sections[this.id].forEach((el) => {
      if (typeof el.onBlockSelect === 'function') {
        el.onBlockSelect(e);
      }
    });
  },
  onBlockDeselect(e) {
    sections[this.id].forEach((el) => {
      if (typeof el.onBlockSelect === 'function') {
        el.onBlockDeselect(e);
      }
    });
  },
};

register('announcement', [bar]);
